import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ClientAccessSettingsProps } from '../../ClientAccess.types';
import { Onboarding } from './sections/Onboarding/Onboarding';
import { Separator } from '../../../CommonComponents/OPL/Separator/Separator';
import { Dashboard } from './sections/Dashboard/Dashboard';
import { Other } from './sections/Other/Other';

export const ClientAccessSettings = (props: ClientAccessSettingsProps) => {
  const { onboardingWorkflowOptions } = props;

  return (
    <Box>
      {/* Don't show the onboarding section if there are no onboarding workflows available (AB#251142) */}
      {onboardingWorkflowOptions.length > 0 && (
        <>
          <Onboarding {...props} />

          <Separator />
        </>
      )}

      <Dashboard {...props} />

      <Other {...props} />
    </Box>
  );
};
